import React from 'react'

const PendingSubscriptionInfo = (props) => {
    const { subscription } = props
    return (
      <section>
        <div className="title site-color">Subscription</div>
        <div className="detail">
          <div className="title site-color">Subscription Plan</div>
          <div className="main">
            <div className="key">{ subscription.subscriptionPlanInfo && subscription.subscriptionPlanInfo.name }</div>
          </div>
          <div className="status">PENDING</div>
        </div>
        <div className="clearfix"></div>
      </section>)
  }

export default PendingSubscriptionInfo;
